const TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';


const TokenService = {
  getToken() {
    const now = new Date();
    const tokenObject = localStorage.getItem(TOKEN_KEY);
    if (!tokenObject) {
      return null;
    }
    const token = JSON.parse(localStorage.getItem(TOKEN_KEY));
    if (now.getTime() > token.expiry) {
      this.removeToken();
      return null;
    }
    return token.value;
  },

  saveToken(accessToken, expiry) {
    const now = new Date();
    const token = {
      value: accessToken,
      expiry: now.getTime() + (expiry * 1000),
    };
    localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

};

export default TokenService;
